"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueBuilder = exports.PropertyBuilder = exports.StatementBuilder = exports.LabelBuilder = exports.RevisionBuilder = exports.AssetBuilder = exports.Asset = exports.Revision = exports.Statement = exports.Value = exports.Property = exports.Label = exports.DataType = void 0;
var modena_1 = require("@axelity/modena");
var DataType;
(function (DataType) {
    DataType["NONE"] = "NONE";
    DataType["BOOLEAN"] = "BOOL";
    DataType["DATE"] = "DATE";
    DataType["TIME"] = "TIME";
    DataType["DATETIME"] = "DATETIME";
    DataType["INTEGER"] = "INT";
    DataType["FLOAT"] = "FLOAT";
    DataType["STRING"] = "STRING";
    DataType["URL"] = "URL";
    DataType["ITEM"] = "ITEM";
    DataType["PROPERTY"] = "PROP";
    DataType["GEOCOORDINATES"] = "GEO";
    DataType["DURATION"] = "DURATION";
    DataType["MEDIAFILE"] = "MEDIA";
})(DataType = exports.DataType || (exports.DataType = {}));
var Label = /** @class */ (function () {
    function Label(labelBuilder) {
        this.locale = labelBuilder.locale;
        this.value = labelBuilder.value;
        this.description = labelBuilder.description;
        this.aliases = labelBuilder.aliases;
    }
    Label.toLabel = function (data) {
        if (!data)
            return undefined;
        var obj = {};
        if (typeof data === 'string') {
            obj = JSON.parse(data);
        }
        else {
            obj = data;
        }
        return new LabelBuilder()
            .setLocale(obj['locale'])
            .setValue(obj['value'])
            .setAliases(obj['aliases'])
            .setDescription(obj['description'])
            .build();
    };
    return Label;
}());
exports.Label = Label;
var Property = /** @class */ (function () {
    function Property(propertyBuilder) {
        this.labels = propertyBuilder.labels;
        this.identifier = propertyBuilder.identifier;
        this.dataType = propertyBuilder.dataType;
        this.statements = propertyBuilder.statements;
    }
    Property.prototype.getLabel = function (locale) {
        if (this.labels && this.labels.length > 0) {
            for (var i = 0; i < this.labels.length; i++) {
                var label = this.labels[i];
                if (label.locale === locale) {
                    return label;
                }
            }
            // fallback
            return this.labels[0];
        }
        return;
    };
    Property.toProperty = function (data) {
        if (!data)
            return undefined;
        var obj = {};
        if (typeof data === 'string') {
            obj = JSON.parse(data);
        }
        else {
            obj = data;
        }
        var labels = obj['labels']
            ? obj['labels'].map(function (_label) {
                return Label.toLabel(_label);
            })
            : undefined;
        var statements = obj['statements']
            ? obj['statements'].map(function (_statement) {
                return Statement.toStatement(_statement);
            })
            : undefined;
        return new PropertyBuilder(obj['identifier'])
            .setDataType(DataType[obj['dataType']])
            .setLabels(labels)
            .setStatements(statements)
            .build();
    };
    return Property;
}());
exports.Property = Property;
var Value = /** @class */ (function () {
    function Value(valueBuilder) {
        this.value = valueBuilder.value;
        this.qualifiers = valueBuilder.qualifiers;
    }
    Value.toValue = function (data) {
        if (!data)
            return undefined;
        var obj = {};
        if (typeof data === 'string') {
            obj = JSON.parse(data);
        }
        else {
            obj = data;
        }
        var qualifiers = obj['qualifiers']
            ? obj['qualifiers'].map(function (_statement) {
                return Statement.toStatement(_statement);
            })
            : undefined;
        return new ValueBuilder()
            .setValue(obj['value'])
            .setQualifiers(qualifiers)
            .build();
    };
    return Value;
}());
exports.Value = Value;
var Statement = /** @class */ (function () {
    function Statement(statementBuilder) {
        this.property = statementBuilder.property;
        this.values = statementBuilder.values;
    }
    Statement.toStatement = function (data) {
        if (!data)
            return undefined;
        var obj = {};
        if (typeof data === 'string') {
            obj = JSON.parse(data);
        }
        else {
            obj = data;
        }
        var property = Property.toProperty(obj['property']);
        var values = obj['values']
            ? obj['values'].map(function (_value) {
                return Value.toValue(_value);
            })
            : undefined;
        return new StatementBuilder()
            .setValues(values)
            .setProperty(property)
            .build();
    };
    return Statement;
}());
exports.Statement = Statement;
var Revision = /** @class */ (function () {
    function Revision(builder) {
        this.issued = builder.issued;
        this.identifier = builder.identifier;
        this.labels = builder.lables;
        this.statements = builder.statements;
    }
    Revision.prototype.getLabel = function (locale) {
        if (this.labels && this.labels.length > 0) {
            for (var i = 0; i < this.labels.length; i++) {
                var label = this.labels[i];
                if (label.locale === locale) {
                    return label;
                }
            }
            // fallback
            return this.labels[0];
        }
        return;
    };
    Revision.prototype.getStatement = function (propertyIdentifier) {
        if (this.statements && this.statements.length > 0) {
            for (var i = 0; i < this.statements.length; i++) {
                var statement = this.statements[i];
                if (statement.property.identifier === propertyIdentifier) {
                    return statement;
                }
            }
        }
        return;
    };
    Revision.toRevision = function (data) {
        if (!data)
            return undefined;
        var obj = {};
        if (typeof data === 'string') {
            obj = JSON.parse(data);
        }
        else {
            obj = data;
        }
        var labels = obj['labels']
            ? obj['labels'].map(function (_label) {
                return Label.toLabel(_label);
            })
            : undefined;
        var statements = obj['statements']
            ? obj['statements'].map(function (_statement) {
                return Statement.toStatement(_statement);
            })
            : undefined;
        return new RevisionBuilder({
            identifier: obj['identifier'],
            issued: obj['issued'],
        })
            .setLabels(labels)
            .setStatements(statements)
            .build();
    };
    return Revision;
}());
exports.Revision = Revision;
var Asset = /** @class */ (function () {
    function Asset(builder) {
        this.identifier = builder.identifier;
        this.scope = builder.scope;
        this.revisions = builder.revisions;
    }
    Asset.prototype.sortRevisions = function (descending) {
        if (this.revisions && this.revisions.length > 0) {
            return this.revisions.sort(function (a, b) {
                if (descending) {
                    return b.issued - a.issued;
                }
                else {
                    return a.issued - b.issued;
                }
            });
        }
        else {
            return;
        }
    };
    Asset.prototype.getLatestRevision = function () {
        if (this.revisions && this.revisions.length > 0) {
            var _revisions = this.sortRevisions(true);
            return _revisions[0];
        }
        else {
            return;
        }
    };
    Asset.prototype.toUint8Array = function () {
        var s = JSON.stringify(this);
        var e = new Uint8Array(s.length);
        for (var i = 0; i < s.length; i += 1) {
            e[i] = s.charCodeAt(i);
        }
        return e;
    };
    Asset.toAsset = function (data) {
        if (!data)
            return undefined;
        var obj = {};
        if (typeof data === 'string') {
            obj = JSON.parse(data);
        }
        else if (data instanceof Uint8Array) {
            var d = '';
            for (var i = 0; i < data.length; i += 1) {
                d += String.fromCharCode(data[i]);
            }
            obj = JSON.parse(d);
        }
        else {
            obj = data;
        }
        var revisions = obj['revisions']
            ? obj['revisions'].map(function (_revision) {
                return Revision.toRevision(_revision);
            })
            : undefined;
        return new AssetBuilder({
            identifier: obj['identifier'],
            scope: obj['scope'],
        })
            .setRevisions(revisions)
            .build();
    };
    return Asset;
}());
exports.Asset = Asset;
var AssetBuilder = /** @class */ (function () {
    function AssetBuilder(_a) {
        var identifier = _a.identifier, scope = _a.scope;
        this._identifier = identifier || modena_1.Utilities.uniqueId();
        this._scope = scope.trim().toUpperCase();
    }
    AssetBuilder.prototype.addRevision = function (builder) {
        if (!this._revisions)
            this._revisions = [];
        this._revisions = __spreadArray(__spreadArray([], this._revisions), [builder.build()]);
        return this;
    };
    AssetBuilder.prototype.addRevisions = function () {
        var revisions = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            revisions[_i] = arguments[_i];
        }
        if (!this._revisions)
            this._revisions = [];
        this._revisions = __spreadArray(__spreadArray([], this._revisions), revisions);
        return this;
    };
    AssetBuilder.prototype.setRevisions = function (revisions) {
        this._revisions =
            revisions && revisions !== null ? __spreadArray([], revisions) : undefined;
        return this;
    };
    AssetBuilder.prototype.build = function () {
        return new Asset(this);
    };
    Object.defineProperty(AssetBuilder.prototype, "revisions", {
        get: function () {
            return this._revisions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssetBuilder.prototype, "identifier", {
        get: function () {
            return this._identifier;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AssetBuilder.prototype, "scope", {
        get: function () {
            return this._scope;
        },
        enumerable: false,
        configurable: true
    });
    return AssetBuilder;
}());
exports.AssetBuilder = AssetBuilder;
var RevisionBuilder = /** @class */ (function () {
    function RevisionBuilder(_a) {
        var identifier = _a.identifier, issued = _a.issued;
        this._identifier = identifier || modena_1.Utilities.uniqueId();
        this._issued = issued || new Date().getTime();
    }
    RevisionBuilder.prototype.addLabel = function (builder) {
        if (!this._labels)
            this._labels = [];
        this._labels = __spreadArray(__spreadArray([], this._labels), [builder.build()]);
        return this;
    };
    RevisionBuilder.prototype.addLabels = function () {
        var labels = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            labels[_i] = arguments[_i];
        }
        if (!this._labels)
            this._labels = [];
        this._labels = __spreadArray(__spreadArray([], this._labels), labels);
        return this;
    };
    RevisionBuilder.prototype.setLabels = function (labels) {
        this._labels = labels && labels !== null ? __spreadArray([], labels) : undefined;
        return this;
    };
    RevisionBuilder.prototype.addStatement = function (builder) {
        if (!this._statements)
            this._statements = [];
        this._statements = __spreadArray(__spreadArray([], this._statements), [builder.build()]);
        return this;
    };
    RevisionBuilder.prototype.addStatements = function () {
        var statements = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            statements[_i] = arguments[_i];
        }
        if (!this._statements)
            this._statements = [];
        this._statements = __spreadArray(__spreadArray([], this._statements), statements);
        return this;
    };
    RevisionBuilder.prototype.setStatements = function (statements) {
        this._statements =
            statements && statements !== null ? __spreadArray([], statements) : undefined;
        return this;
    };
    RevisionBuilder.prototype.build = function () {
        return new Revision(this);
    };
    Object.defineProperty(RevisionBuilder.prototype, "identifier", {
        get: function () {
            return this._identifier;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RevisionBuilder.prototype, "lables", {
        get: function () {
            return this._labels;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RevisionBuilder.prototype, "statements", {
        get: function () {
            return this._statements;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RevisionBuilder.prototype, "issued", {
        get: function () {
            return this._issued;
        },
        enumerable: false,
        configurable: true
    });
    return RevisionBuilder;
}());
exports.RevisionBuilder = RevisionBuilder;
var LabelBuilder = /** @class */ (function () {
    function LabelBuilder() {
    }
    LabelBuilder.prototype.setLocale = function (locale) {
        this._locale = locale;
        return this;
    };
    LabelBuilder.prototype.setValue = function (value) {
        this._value = value;
        return this;
    };
    LabelBuilder.prototype.setDescription = function (description) {
        this._description = description;
        return this;
    };
    LabelBuilder.prototype.addAlias = function (alias) {
        if (!this._aliases)
            this._aliases = [];
        this._aliases = __spreadArray(__spreadArray([], this._aliases), [alias]);
        return this;
    };
    LabelBuilder.prototype.addAliases = function () {
        var aliases = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            aliases[_i] = arguments[_i];
        }
        if (!this._aliases)
            this._aliases = [];
        this._aliases = __spreadArray(__spreadArray([], this._aliases), aliases);
        return this;
    };
    LabelBuilder.prototype.setAliases = function (aliases) {
        this._aliases = aliases && aliases !== null ? __spreadArray([], aliases) : undefined;
        return this;
    };
    LabelBuilder.prototype.build = function () {
        return new Label(this);
    };
    Object.defineProperty(LabelBuilder.prototype, "locale", {
        get: function () {
            return this._locale;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LabelBuilder.prototype, "value", {
        get: function () {
            return this._value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LabelBuilder.prototype, "description", {
        get: function () {
            return this._description;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LabelBuilder.prototype, "aliases", {
        get: function () {
            return this._aliases;
        },
        enumerable: false,
        configurable: true
    });
    return LabelBuilder;
}());
exports.LabelBuilder = LabelBuilder;
var StatementBuilder = /** @class */ (function () {
    function StatementBuilder() {
    }
    StatementBuilder.prototype.setProperty = function (property) {
        this._property = property;
        return this;
    };
    StatementBuilder.prototype.buildProperty = function (builder) {
        this._property = builder.build();
        return this;
    };
    StatementBuilder.prototype.addValue = function (builder) {
        if (!this._values)
            this._values = [];
        this._values = __spreadArray(__spreadArray([], this._values), [builder.build()]);
        return this;
    };
    StatementBuilder.prototype.addValues = function () {
        var values = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            values[_i] = arguments[_i];
        }
        if (!this._values)
            this._values = [];
        this._values = __spreadArray(__spreadArray([], this._values), values);
        return this;
    };
    StatementBuilder.prototype.setValues = function (values) {
        this._values = values && values !== null ? __spreadArray([], values) : undefined;
        return this;
    };
    StatementBuilder.prototype.build = function () {
        return new Statement(this);
    };
    Object.defineProperty(StatementBuilder.prototype, "property", {
        get: function () {
            return this._property;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StatementBuilder.prototype, "values", {
        get: function () {
            return this._values;
        },
        enumerable: false,
        configurable: true
    });
    return StatementBuilder;
}());
exports.StatementBuilder = StatementBuilder;
var PropertyBuilder = /** @class */ (function () {
    function PropertyBuilder(identifier) {
        this._identifier = identifier;
        this._dataType = DataType.NONE;
    }
    PropertyBuilder.prototype.setDataType = function (dataType) {
        this._dataType = dataType;
        return this;
    };
    PropertyBuilder.prototype.addLabel = function (builder) {
        if (!this._labels)
            this._labels = [];
        this._labels = __spreadArray(__spreadArray([], this._labels), [builder.build()]);
        return this;
    };
    PropertyBuilder.prototype.addLabels = function () {
        var labels = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            labels[_i] = arguments[_i];
        }
        if (!this._labels)
            this._labels = [];
        this._labels = __spreadArray(__spreadArray([], this._labels), labels);
        return this;
    };
    PropertyBuilder.prototype.setLabels = function (labels) {
        this._labels = labels && labels !== null ? __spreadArray([], labels) : undefined;
        return this;
    };
    PropertyBuilder.prototype.addStatement = function (builder) {
        if (!this._statements)
            this._statements = [];
        this._statements = __spreadArray(__spreadArray([], this._statements), [builder.build()]);
        return this;
    };
    PropertyBuilder.prototype.addStatements = function () {
        var statements = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            statements[_i] = arguments[_i];
        }
        if (!this._statements)
            this._statements = [];
        this._statements = __spreadArray(__spreadArray([], this._statements), statements);
        return this;
    };
    PropertyBuilder.prototype.setStatements = function (statements) {
        this._statements =
            statements && statements !== null ? __spreadArray([], statements) : undefined;
        return this;
    };
    PropertyBuilder.prototype.build = function () {
        return new Property(this);
    };
    Object.defineProperty(PropertyBuilder.prototype, "dataType", {
        get: function () {
            return this._dataType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PropertyBuilder.prototype, "identifier", {
        get: function () {
            return this._identifier;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PropertyBuilder.prototype, "labels", {
        get: function () {
            return this._labels;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PropertyBuilder.prototype, "statements", {
        get: function () {
            return this._statements;
        },
        enumerable: false,
        configurable: true
    });
    return PropertyBuilder;
}());
exports.PropertyBuilder = PropertyBuilder;
var ValueBuilder = /** @class */ (function () {
    function ValueBuilder() {
    }
    ValueBuilder.prototype.setValue = function (value) {
        this._value = value;
        return this;
    };
    ValueBuilder.prototype.addQualifier = function (builder) {
        if (!this._qualifiers)
            this._qualifiers = [];
        this._qualifiers = __spreadArray(__spreadArray([], this._qualifiers), [builder.build()]);
        return this;
    };
    ValueBuilder.prototype.addQualifiers = function () {
        var qualifiers = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            qualifiers[_i] = arguments[_i];
        }
        if (!this._qualifiers)
            this._qualifiers = [];
        this._qualifiers = __spreadArray(__spreadArray([], this._qualifiers), qualifiers);
        return this;
    };
    ValueBuilder.prototype.setQualifiers = function (qualifiers) {
        this._qualifiers =
            qualifiers && qualifiers !== null ? __spreadArray([], qualifiers) : undefined;
        return this;
    };
    ValueBuilder.prototype.build = function () {
        return new Value(this);
    };
    Object.defineProperty(ValueBuilder.prototype, "qualifiers", {
        get: function () {
            return this._qualifiers;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ValueBuilder.prototype, "value", {
        get: function () {
            return this._value;
        },
        enumerable: false,
        configurable: true
    });
    return ValueBuilder;
}());
exports.ValueBuilder = ValueBuilder;
//# sourceMappingURL=asset.js.map